import {
    Input,
    Select,
    SelectItem,
    DatePicker,
    Switch,
    Alert,
} from "@heroui/react";
import { PhoneInput } from "@/components/ui";
import { Controller } from "react-hook-form";
import { parseDate } from "@internationalized/date";
import { LuInfo } from "react-icons/lu";

const PersonalInfoStep = ({
    register,
    errors,
    control,
    watch,
    religions = [],
    maritalStatuses = [],
    roles = [],
    isEdit = false,
    hasUser = false,
    userEmail = "",
}) => {
    const createUser = watch("create_user");

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {/* Nama Lengkap & Jenis Kelamin */}
            <Input
                label="Nama Lengkap (Sesuai KTP)"
                placeholder="Masukkan nama lengkap staff"
                {...register("name", { required: "Nama wajib diisi" })}
                errorMessage={errors.name?.message}
                isInvalid={!!errors.name}
                variant="bordered"

                isRequired
            />

            <Controller
                name="gender_id"
                control={control}
                render={({ field }) => (
                    <Select
                        label="Jenis Kelamin"
                        placeholder="Pilih"
                        selectedKeys={
                            field.value
                                ? new Set([String(field.value)])
                                : new Set()
                        }
                        onSelectionChange={(keys) =>
                            field.onChange(Array.from(keys)[0])
                        }
                        variant="bordered"
        
                    >
                        <SelectItem key="1">Perempuan</SelectItem>
                        <SelectItem key="2">Laki-laki</SelectItem>
                    </Select>
                )}
            />

            {/* WhatsApp & Handphone */}
            <Controller
                name="whatsapp"
                control={control}
                rules={{ required: "No WhatsApp wajib diisi" }}
                render={({ field }) => (
                    <PhoneInput
                        inputProps={{
                            label: "Nomor WhatsApp",
                            isRequired: true,


                        }}
                        autocompleteProps={{}}
                        value={field.value}
                        onChange={field.onChange}
                        isInvalid={!!errors.whatsapp}
                        errorMessage={errors.whatsapp?.message}
                    />
                )}
            />

            <Controller
                name="handphone"
                control={control}
                render={({ field }) => (
                    <PhoneInput
                        inputProps={{
                            label: "Nomor Handphone",


                        }}
                        autocompleteProps={{}}
                        value={field.value}
                        onChange={field.onChange}
                    />
                )}
            />

            {/* Tempat Lahir, Tanggal Lahir, Agama, Status Kawin - 4 kolom */}
            <div className="grid grid-cols-2 gap-4 md:col-span-2 md:grid-cols-4">
                <Input
                    label="Tempat Lahir"
                    placeholder="Masukkan tempat lahir"
                    {...register("birth_place")}
                    variant="bordered"
    
                />

                <Controller
                    name="birth_date"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            label="Tanggal Lahir"
                            value={field.value ? parseDate(field.value) : null}
                            onChange={(date) =>
                                field.onChange(date ? date.toString() : "")
                            }
                            variant="bordered"
            
                            showMonthAndYearPickers
                        />
                    )}
                />

                <Controller
                    name="religion_id"
                    control={control}
                    render={({ field }) => (
                        <Select
                            label="Agama"
                            placeholder="Pilih"
                            selectedKeys={
                                field.value
                                    ? new Set([String(field.value)])
                                    : new Set()
                            }
                            onSelectionChange={(keys) =>
                                field.onChange(Array.from(keys)[0])
                            }
                            variant="bordered"
            
                        >
                            {religions.map((item) => (
                                <SelectItem
                                    key={String(item.value)}
                                    value={item.value}
                                >
                                    {item.title}
                                </SelectItem>
                            ))}
                        </Select>
                    )}
                />

                <Controller
                    name="marital_status_id"
                    control={control}
                    render={({ field }) => (
                        <Select
                            label="Status Kawin"
                            placeholder="Pilih"
                            selectedKeys={
                                field.value
                                    ? new Set([String(field.value)])
                                    : new Set()
                            }
                            onSelectionChange={(keys) =>
                                field.onChange(Array.from(keys)[0])
                            }
                            variant="bordered"
            
                        >
                            {maritalStatuses.map((item) => (
                                <SelectItem
                                    key={String(item.value)}
                                    value={item.value}
                                >
                                    {item.title}
                                </SelectItem>
                            ))}
                        </Select>
                    )}
                />
            </div>

            {/* Buat Akun User */}
            <div className="border-default-200 flex flex-col gap-4 rounded-lg border p-4 md:col-span-2">
                {isEdit && hasUser ? (
                    <>
                        <Alert
                            color="success"
                            variant="flat"
                            icon={
                                <div className="flex items-center justify-center">
                                    <LuInfo size={18} className="mx-auto" />
                                </div>
                            }
                            classNames={{ description: "text-xs" }}
                            title="Staff ini sudah memiliki akun user"
                            description={`Akun staff sudah terdaftar dengan email ${userEmail}.`}
                        />
                        <Controller
                            name="role_id"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    label="Hak Akses"
                                    placeholder="Pilih role"
                                    selectedKeys={
                                        field.value
                                            ? new Set([String(field.value)])
                                            : new Set()
                                    }
                                    onSelectionChange={(keys) =>
                                        field.onChange(Array.from(keys)[0])
                                    }
                                    errorMessage={errors.role_id?.message}
                                    isInvalid={!!errors.role_id}
                                    variant="bordered"
                                >
                                    {roles.map((item) => (
                                        <SelectItem
                                            key={String(item.value)}
                                            value={item.value}
                                        >
                                            {item.title}
                                        </SelectItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </>
                ) : (
                    <>
                        <Controller
                            name="create_user"
                            control={control}
                            render={({ field }) => (
                                <Switch
                                    isSelected={field.value}
                                    onValueChange={field.onChange}
                                    size="sm"
                                    classNames={{ label: "text-sm" }}
                                >
                                    Buat akun user untuk staff ini
                                </Switch>
                            )}
                        />

                        {createUser && (
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <Input
                                    label="Email"
                                    type="email"
                                    placeholder="Masukkan email"
                                    {...register("email", {
                                        required: createUser
                                            ? "Email wajib diisi"
                                            : false,
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: "Format email tidak valid",
                                        },
                                    })}
                                    errorMessage={errors.email?.message}
                                    isInvalid={!!errors.email}
                                    variant="bordered"
                                    isRequired
                                />
                                <Controller
                                    name="role_id"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            label="Role Akses"
                                            placeholder="Pilih role"
                                            selectedKeys={
                                                field.value
                                                    ? new Set([
                                                          String(field.value),
                                                      ])
                                                    : new Set()
                                            }
                                            onSelectionChange={(keys) =>
                                                field.onChange(
                                                    Array.from(keys)[0],
                                                )
                                            }
                                            errorMessage={
                                                errors.role_id?.message
                                            }
                                            isInvalid={!!errors.role_id}
                                            variant="bordered"
                                        >
                                            {roles.map((item) => (
                                                <SelectItem
                                                    key={String(item.value)}
                                                    value={item.value}
                                                >
                                                    {item.title}
                                                </SelectItem>
                                            ))}
                                        </Select>
                                    )}
                                />
                                <Input
                                    label="Password"
                                    type="password"
                                    placeholder="Masukkan password"
                                    {...register("password", {
                                        required: createUser
                                            ? "Password wajib diisi"
                                            : false,
                                        minLength: {
                                            value: 8,
                                            message:
                                                "Password minimal 8 karakter",
                                        },
                                    })}
                                    errorMessage={errors.password?.message}
                                    isInvalid={!!errors.password}
                                    variant="bordered"
                                    isRequired
                                />
                                <Input
                                    label="Konfirmasi Password"
                                    type="password"
                                    placeholder="Ulangi password"
                                    {...register("password_confirmation", {
                                        required: createUser
                                            ? "Konfirmasi password wajib diisi"
                                            : false,
                                        validate: (value) =>
                                            !createUser ||
                                            value === watch("password") ||
                                            "Password tidak cocok",
                                    })}
                                    errorMessage={
                                        errors.password_confirmation?.message
                                    }
                                    isInvalid={!!errors.password_confirmation}
                                    variant="bordered"
                                    isRequired
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default PersonalInfoStep;
